
import PageHeader from "../components/PageHeader";
import HireDevelopers from "../components/Hire-developers"
import TrustedPartners from "../components/Trusted-Partners";
import WhyHireDedicatedDevelopers from "../components/Why-Hire-Dedicated-Developers";
import DreamTeam from "../components/Dream-team";
import OurTestimonial from "../components/Our-Testimonial";
import Faq from "../components/Faq";

const HireResources = () => {
    return (
        <>
            <PageHeader pagetitle="Hire Resources" breadcrumbMenu="Home" breadcrumbMenuActive="Hire Resources" image="/images/hire-developers.jpg" />
            <HireDevelopers />
            <WhyHireDedicatedDevelopers />
            {/* <TrustedPartners /> */}
            <DreamTeam />
            <Faq />
            {/* <div className="our-testimonial-gap">
                <OurTestimonial />
            </div> */}
        </>
    )
}

export default HireResources;